<template>
  <div id="app" class="app-container">
    <router-view/>
  </div>
</template>
<script setup>
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const isHomePage = ref(route.path === '/');

watch(() => route.path, (newPath) => {
  isHomePage.value = newPath === '/';
});
</script>
<style>
</style>